<template lang="pug">
v-row
  v-col.d-flex.py-0.py-md-3.px-4
    v-row
      v-col.d-flex.pt-md-0.pa-2(
        v-for="app in miniApps"
        :key="app.name"
        cols="4"
        md="2"
        @click="onMiniAppClick(app)"
      )
        v-sheet.d-flex.pa-2.pa-sm-4.flex-grow-1.align-self-stretch.rounded-xl.justify-center.align-center(
          :class="app.soon ? 're-mini-app-disabled' : 're-cursor-pointer'"
        )
          .d-flex.flex-column.align-center
            v-avatar.mt-md-1(color="reBackground" :size="avatarSize")
              v-icon(:size="avatarIconSize") {{ app.icon }}
            //- На узких телефонах (375pt / 3 плитки) паддинги не оставляли места самым
            //- длинным словам («лояльности», kk «жазылымдарым») и слово рвалось посреди -
            //- отрицательные маргины отдают подписи всю ширину плитки
            p.re-tile-title.text-center.text-subtitle-2.text-sm-subtitle-1.text-md-h4.mt-2.mt-md-3.mx-n2.mx-sm-0(style="min-height: 50px; overflow-wrap: break-word;") {{ tileTitle(app) }}
        div(v-if="app.soon" style="position: relative;")
          .text-subtitle-2.soon-badge {{ $t('скоро') }}
        div(v-else-if="app.isNew" style="position: relative;")
          .text-subtitle-2.new-badge new
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {

  computed: {
    ...mapState({
      organization: state => state.cashRegisters.cashRegister.organization,
      roles: state => state.cashRegisters.cashRegister.roles,
    }),

    hasAccountNumber() {
      return this.organization.accountNumber
    },

    isOwner() {
      return (this.roles || []).find(r => r === 'OWNER') !== undefined
    },

    isLarge() {
      return this.$vuetify.breakpoint.mdAndUp
    },

    avatarSize() {
      return this.isLarge ? '80px' : '65px'
    },

    avatarIconSize() {
      return this.isLarge ? '44px' : '36px'
    },

    miniApps() {
      return [
        { name: 'inventory', icon: 'mdi-package-variant', titleKey: 'товары_и_услуги' },
        { name: 'loyalty', icon: 'mdi-star', titleKey: 'программа_лояльности' },
        { name: 'resalyq', icon: 'mdi-bank', titleKey: 'налоги' },
        // ЭДО - только владельцу, кассирам не показываем
        ...(this.isOwner
          ? [{
            name: 'edo',
            icon: 'mdi-file-document-outline',
            titleKey: 'эдо',
            isNew: true,
          }]
          : []),
        { name: 'analytics', icon: 'mdi-chart-box', titleKey: 'аналитика' },
        ...(this.hasAccountNumber
          ? [{
            name: 'account',
            icon: 'mdi-credit-card-check-outline',
            titleKey: 'мои_подписки',
            stacked: true,
          }]
          : []),
      ]
    },
  },

  methods: {
    ...mapActions({
      analyticsLogEvent: 'analytics/logEvent',
      openMiniApp: 'miniapp/open',
    }),

    // stacked: у плитки с коротким двусловным заголовком («Мои подписки») на телефонах
    // каждое слово стоит на своей строке - \n превращается в перенос через
    // white-space pre-line в мобильном media query, на десктопе схлопывается в пробел
    tileTitle(app) {
      const title = this.$t(app.titleKey)
      return app.stacked ? title.replace(/ /g, '\n') : title
    },

    onMiniAppClick(app) {
      if (app.soon) return
      this.openMiniApp({ name: app.name })
      this.analyticsLogEvent({
        eventName: 're_miniapp_clicked_main_page',
        eventProperties: { miniappName: app.name },
      })
    },
  },
}
</script>
<style scoped lang="stylus">
.new-badge
  position absolute
  top 16px
  right -3px
  background-color rgb(244, 67, 54)
  padding 1px 7px
  border-top-left-radius 7px
  border-bottom-left-radius 7px
  border-top-right-radius 3px
  border-bottom-right-radius 3px
  color white
.soon-badge
  position absolute
  top 16px
  right -3px
  background-color rgb(244, 67, 54)
  padding 1px 7px
  border-top-left-radius 7px
  border-bottom-left-radius 7px
  border-top-right-radius 3px
  border-bottom-right-radius 3px
  color white
  white-space nowrap
.re-mini-app-disabled
  opacity 0.5
  cursor default
@media (max-width: 599.98px)
  .re-tile-title
    white-space pre-line
</style>
